import React, { useState } from "react";

function QuestionStep({
  question,
  value,
  onChange,
  onNext,
  onBack,
  isLast,
  onFinish
}) {
  const [loading, setLoading] = useState(false);

  const handleNextClick = async () => {
    // Normal next
    if (!isLast) {
      onNext();
      return;
    }

    // Last question → call external API
    try {
      setLoading(true);
      await onFinish();
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="visa-card">
      <h2>{question.title}</h2>
      <p>{question.question}</p>

      {question.answers.map((ans) => (
        <label key={ans.id} className="visa-radio">
          <input
            type="radio"
            checked={value?.id === ans.id}
            onChange={() => onChange(ans)}
          />
          <span>
            {ans.answer}{" "}
            <strong className="cshide-class">
              ({ans.score} points)
            </strong>
          </span>
        </label>
      ))}

      <div className="form-actions">
        <button
          type="button"
          className="btn-back"
          onClick={onBack}
          disabled={loading}
        >
          Back
        </button>

        <button
          type="button"
          className="btn-next"
          disabled={!value || loading}
          onClick={handleNextClick}
        >
          {loading
            ? "Submitting..."
            : isLast
            ? "Finish"
            : "Next"}
        </button>
      </div>
    </section>
  );
}

export default QuestionStep;
